import { FC } from 'react'

const ChevronLeft: FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  fill,
  height,
  width,
  ...rest
}) => {
  return (
    <svg
      className={className}
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'
        fill={fill || 'currentColor'}
      />
    </svg>
  )
}

export default ChevronLeft
